import { render, staticRenderFns } from "./OffMarketRegistration.vue?vue&type=template&id=36d7ebc8&scoped=true&"
import script from "./OffMarketRegistration.vue?vue&type=script&lang=ts&"
export * from "./OffMarketRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./OffMarketRegistration.vue?vue&type=style&index=0&id=36d7ebc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d7ebc8",
  null
  
)

export default component.exports